import { action, makeObservable } from 'mobx'

import ModalViewModel from 'infra/ModalViewModel'
import { Router } from 'types/definitions'
import link from 'infra/link'

export default class OverachieverViewModel extends ModalViewModel {
  /**
   * Whether the user has already seen the modal or not.
   */
  private hasShown = false

  constructor(private router: Router) {
    super()
    makeObservable(this)
  }

  /**
   * Shows the modal once.
   */
  showOnce() {
    if (this.hasShown) {
      return
    }

    this.hasShown = true
    super.show()
  }

  /**
   * Redirects to the jobs page.
   */
  @action.bound
  finishOpenJobs() {
    this.router.replace(link.jobs())
    this.close()
  }
}
